import React from 'react'
import { FlexContainer, PlaceField } from '@busie/ui-kit'
import { GooglePlace } from '@busie/utils'
import { MarkerStyled, ProgressLineStyled } from '~/components'

interface Props {
  markerLabel: string
  inputPlaceholder: string
  isStop: boolean
  isEnd: boolean
  onSelect: (place: GooglePlace) => void
}

const PlaceInput: React.FC<React.PropsWithChildren<Props>> = ({
  markerLabel,
  isStop,
  isEnd,
  inputPlaceholder,
  onSelect,
}) => {
  return (
    <FlexContainer w="100%" pl={2} pr={2} align="center" columnGap={1.5}>
      <MarkerStyled isStop={isStop}>
        {markerLabel}
        {!isEnd && <ProgressLineStyled />}
      </MarkerStyled>
      <PlaceField
        onSelect={onSelect}
        placeholder={inputPlaceholder}
        width="330px"
        margin="0px"
      />
    </FlexContainer>
  )
}

export default PlaceInput
